var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-table",
    {
      staticStyle: { width: "100%" },
      attrs: {
        border: "",
        "header-cell-style": {
          backgroundColor: "#FDEFE7",
          color: "#000000",
        },
        data: _vm.tableData,
      },
    },
    [
      _c("el-table-column", {
        attrs: {
          fixed: "left",
          align: "center",
          prop: "stockCompanyId",
          label: "供应商",
          width: "180",
        },
      }),
      _c("el-table-column", {
        attrs: {
          align: "center",
          prop: "stockCompanyName",
          label: "供应商名称",
        },
      }),
      _c("el-table-column", {
        attrs: {
          align: "center",
          prop: "address",
          label: "总订单数及金额",
          width: "180",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _c("p", [
                  _vm._v("子订单数："),
                  _c("span", { staticStyle: { color: "red" } }, [
                    _vm._v(_vm._s(scope.row.childrenOrderNumber)),
                  ]),
                ]),
                _c("p", [
                  _vm._v("金额："),
                  _c("span", [_vm._v("¥" + _vm._s(scope.row.price))]),
                ]),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: { align: "center", prop: "name", label: "待确认子订单数及金额" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _c("p", [
                  _vm._v("总订单数："),
                  _c("span", { staticStyle: { color: "red" } }, [
                    _vm._v(_vm._s(scope.row.toBeConfirmedNumber)),
                  ]),
                ]),
                _c("p", [
                  _vm._v("金额："),
                  _c("span", [
                    _vm._v("¥" + _vm._s(scope.row.toBeConfirmedPrice)),
                  ]),
                ]),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          align: "center",
          prop: "name",
          label: "操作时间报警",
          width: "180",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }